import React from "react";
import { FiUsers, FiTruck, FiGitMerge, FiHeart } from "react-icons/fi";

const features = [
  { icon: FiUsers, title: "Passenger Rides" },
  { icon: FiTruck, title: "Goods Transport" },
  { icon: FiGitMerge, title: "Heavy Vehicles" },
  { icon: FiHeart, title: "Emergency Ambulance" },
];

export default function WhatDifferent() {
  return (
    <>
      {/* WHAT MAKES TROGO DIFFERENT */}
      <section className="bg-trogoBg py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="inline-flex rounded-full bg-trogoBlue/10 px-4 py-1 text-sm font-semibold text-trogoBlue">
            Our Services
          </span>
          <div className="relative">
            <h2 className="mt-6 text-h2 md:text-4xl font-bold text-trogoBlue">
              What Makes TROGO Different?
            </h2>
            <div className="absolute w-24 h-1 bg-trogoOrange mx-auto mt-3 rounded-full left-0 right-0"></div>
          </div>
          <p className="mt-10 text-lg leading-8 text-slate-600 max-w-2xl mx-auto">
            We are more than just a ride-hailing app. We are a complete
            transport ecosystem designed for every need.
          </p>
          <div className="mt-16 grid md:grid-cols-4 sm:grid-cols-2 gap-8">
            {features.map(({ icon: Icon, title }, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 hover:-translate-y-2"
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-trogoOrange/10 text-trogoOrange mx-auto">
                  <Icon className="h-7 w-7" />
                </div>
                <h3 className="mt-5 font-bold text-lg text-slate-800">
                  {title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
